module.exports = __webpack_public_path__ + "static/img/Bachelor_010601.6d986cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010601.jpg
// module id = 197
// module chunks = 0